import { ConnectionError } from '@lucidlink/sdk';
import { containsNetworkFailure } from '@lucidlink/tscore';
import { WEBFS_FETCH_ABORTED_MESSAGE } from '@lucidlink/workspacemanagement';
// WebFs ClientImpl.disconnect() rejects every in-flight hub request with this
// text; a deliberate disconnect is terminal, any other ConnectionError is a
// dropped socket worth retrying.
const CLIENT_DISCONNECTED_MESSAGE = 'explicitly disconnected';
const isRetryableHubError = (error) => error instanceof ConnectionError &&
    !error.message.includes(CLIENT_DISCONNECTED_MESSAGE);
const isWebFsFetchTimeout = (error) => error instanceof Error &&
    error.message.includes(WEBFS_FETCH_ABORTED_MESSAGE);
// A download has two network paths that fail in different shapes: the browser
// fetch to object storage, and the hub WebSocket behind the WASM metadata lookups.
export const isRetryableDownloadError = (error) => containsNetworkFailure(error) ||
    isWebFsFetchTimeout(error) ||
    isRetryableHubError(error);
